require('/opt/odin/app/frontend/pages/guides/components/v2_featured/index.module.scss');module.exports = "../../app/cells/pages/guides/v2_featured/show.erb";